module.exports = __webpack_public_path__ + "img/HA2502-175.c0d2383d.jpg";